import dateUtils from "../Utils/dateUtils";

export default {
  getTimeLogsFolder: (token, folderid) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(
      `https://www.wrike.com/api/v4/folders/${folderid}/timelogs`,
      requestOptions
    ).then((res) => res.json());
  },

  getTimeLogsFolderThisDay: (token, folderid, n = 0) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let date = new Date();
    date = date.setDate(date.getDate() - n);

    return fetch(
      `https://www.wrike.com/api/v4/folders/${folderid}/timelogs?createdDate={"start":"${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}T00:00:00Z","end":"${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}T23:59:59Z"}`,
      requestOptions
    ).then((res) => res.json());
  },
  getTimeLogsFolderThisWeek: (token, folderid) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let toDay = new Date();

    let firstDayOfWeek = new Date(toDay);
    var day = firstDayOfWeek.getDay(),
        diff = firstDayOfWeek.getDate() - day + (day === 0 ? -6:1);
    firstDayOfWeek = new Date(firstDayOfWeek.setDate(diff));

    return fetch(
      `https://www.wrike.com/api/v4/folders/${folderid}/timelogs?createdDate={"start":"${firstDayOfWeek.getFullYear()}-${firstDayOfWeek.getMonth()+1}-${firstDayOfWeek.getDate()}T00:00:00Z","end":"${toDay.getFullYear()}-${toDay.getMonth()+1}-${toDay.getDate()}T23:59:59Z"}`,
      requestOptions
    ).then((res) => res.json());
  },
  
  getTimeLogsFolderMonth: (token, idFolder, descendants = true) => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `Bearer ${token}`
    );
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let dateString = dateUtils.parseDate(new Date(), false);
    let date = new Date();
    let firstDay = dateString + new Date(date.getFullYear(), date.getMonth(), 1).getDate();
    let lastDay = dateString + new Date(date.getFullYear(), date.getMonth() + 1 , 0).getDate();

    return fetch(
      `https://www.wrike.com/api/v4/folders/${idFolder}/timelogs?descendants=${descendants}&trackedDate={"start":"${firstDay}","end":"${lastDay}"}`,
      requestOptions
    ).then((res) => res.json());
  },

  createTimeLog: (token, idFolder, time) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "wrikeLocale=en; isWhitelabel=false");

    let date = new Date();
    
    var raw = JSON.stringify({"hours": time,"trackedDate":`${date.getFullYear()}-${date.getMonth() +1}-${date.getDate()}`});
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    
    return fetch(`https://www.wrike.com/api/v4//tasks/${idFolder}/timelogs`, requestOptions)
    .then(res => res.json())
  },
};
